import { WizardConfig } from "../../wizard.component";
import { DefineDutyComponent, TripSemantics } from "../create-rule/define-duty/define-duty.component";
import { GetStartedComponent } from "../create-rule/get-started/get-started.component";
import { init } from "../create-rule/init";
import { ReviewAndSubmitComponent } from "../create-rule/review-and-submit/review-and-submit.component";
import { getPayload as getPayloadEnd } from "./payload/define-duty-end.payload";
import { getPayload as getPayloadStart } from "./payload/define-duty-start.payload";

import { getValidatedElements as defineEndDuty_getValidatedComponents } from "./validators/define-duty-end.validator";
import { getValidatedElements as defineStartDuty_getValidatedComponents } from "./validators/define-duty-start.validator";

export const wizardConfig: WizardConfig[] = [
	{
		wizardId: "create-rule",
		title: "Create Rule",
		backToRoute: "/mir-rules",
		init,
		steps: [
			{
				label: "Get Started",
				component: GetStartedComponent,
				noResetBtn: true,
			},
			{
				label: "Duty Start",
				component: DefineDutyComponent,
				data: {
					semantics: TripSemantics.tripStart,
					wantMovementOption: true,
				},
				getValidatedElements: defineStartDuty_getValidatedComponents,
				getPayload: getPayloadStart,
			},
			{
				label: "Duty End",
				component: DefineDutyComponent,
				data: {
					semantics: TripSemantics.tripEnd,
				},
				getValidatedElements: defineEndDuty_getValidatedComponents,
				getPayload: getPayloadEnd,
			},

			{
				label: "Review & Submit",
				component: ReviewAndSubmitComponent,
				noResetBtn: true,
			},
		],
	},
];
